import moment from "moment";
import { PERIOD } from "@/enums/period.enum";
import { FORMAT } from "@/config/date-format";

export const dateRangeFilterMixin = {
  methods: {
    getStartDate() {
      if (this.$route.query.dateFrom && this.$route.query.dateTo) {
        return [this.$route.query.dateFrom, this.$route.query.dateTo];
      }

      return [
        moment()
          .subtract(1, PERIOD.MONTH)
          .add(1, PERIOD.DAY)
          .format(FORMAT.DATE),
        moment().format(FORMAT.DATE)
      ];
    }
  }
};
